var format = 'YYYY-MM-DD[T]HH:mm:ss.SSSZ';

function dateToTimestamp(date) {
	if (!date)
		return null;
	return date.format(format);
}

module.exports = dateToTimestamp;
